import { useSearchParams } from 'react-router-dom';

import AdjustmentOverview from '@/components/inventory/adjustment-overview/AdjustmentOverview';
import PharmacistInventoryTabs from '@/components/inventory/PharmacistInventoryTabs';
import ProductOverview from '@/components/inventory/product-overview/ProductOverview';
import Stocktake from '@/components/inventory/stocktake/Stocktake';
import AdminPageLayout from '@/components/layout/AdminPageLayout';
import { FF_PHARMACIST_STOCKTAKE_IN_PORTAL } from '@/constants/featureFlags';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export const tabs = {
  PRODUCT_OVERVIEW: 'productOverview',
  ADJUSTMENT_OVERVIEW: 'adjustmentOverview',
  STOCKTAKE: 'stocktake',
};

const TAB_SEARCH_PARAM = 'tab';

function PharmacistInventory() {
  const { key } = usePortalPartnerBrand();
  const showStocktake = useFeatureFlag(FF_PHARMACIST_STOCKTAKE_IN_PORTAL);
  const [searchParams, setSearchParams] = useSearchParams();

  const availableTabs = showStocktake ? Object.values(tabs) : [tabs.PRODUCT_OVERVIEW, tabs.ADJUSTMENT_OVERVIEW];
  const tabParam = searchParams.get(TAB_SEARCH_PARAM);
  const activeTab = tabParam && availableTabs.includes(tabParam) ? tabParam : tabs.PRODUCT_OVERVIEW;

  const toggleTab = (tab: string) => setSearchParams({ [TAB_SEARCH_PARAM]: tab }, { replace: true });

  return (
    <AdminPageLayout title="Inventory" themeVariant={key} testId="pharmacist-inventory">
      <PharmacistInventoryTabs activeTab={activeTab} toggleTab={toggleTab} />
      {activeTab === tabs.PRODUCT_OVERVIEW && <ProductOverview />}
      {activeTab === tabs.ADJUSTMENT_OVERVIEW && <AdjustmentOverview />}
      {activeTab === tabs.STOCKTAKE && <Stocktake />}
    </AdminPageLayout>
  );
}

export default PharmacistInventory;
